export default __webpack_public_path__ + "static/media/team_notification.9f548b40.png";